import { createSelector } from 'reselect';
import { listenerMiddleware, startAppListening } from './listenerMiddleware';
import { selectCurrentMemberId } from './modules/backend-service';
import {
  clearInvitationCode,
  followMember,
  selectFollowInviteCode,
} from './modules/follows';
// import PopOverMessage from '../../components/shared/PopOverMessage/PopOverMessage';

const autoFollowPredicateSelector = createSelector(
  selectCurrentMemberId,
  selectFollowInviteCode,
  (memberId, inviteCode) => !!(memberId && inviteCode),
);

export const middleware = () => {
  startAppListening({
    predicate: (_, currentState) => autoFollowPredicateSelector(currentState),

    effect: async (action, listenerApi) => {
      // Prevent further logic if there is not an invitation code - this is to cater for a very small race condition, where
      // between the predicate, and this code running the invite code state has changed. However, unsubscribing and
      // cancelling should really prevent this issue
      const inviteCode = selectFollowInviteCode(listenerApi.getState());
      if (!inviteCode) {
        return;
      }

      // Cancel any other instances of the effect running, and stop listening for new events until this process finishes
      listenerApi.cancelActiveListeners();
      listenerApi.unsubscribe();

      try {
        if (!listenerApi.signal.aborted) {
          await listenerApi.dispatch(followMember(inviteCode)).unwrap();
          listenerApi.dispatch(clearInvitationCode());

          // TODO: we will be adding the success messaging to the users notification stream
          console.log('You are now following {username}.');
        }
      } catch (e) {
        // TODO: we will be adding the error messaging to the users notification stream
        console.log(
          'An error occurred when attempting to follow a user. Sorry!',
        );
      }

      // Resubscribe so that if we ever add another invite code into state, it will continue to work
      listenerApi.subscribe();
    },
  });
  return listenerMiddleware;
};
